<template>
  <v-dialog v-model="showModal" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline secondary white--text">
        Add Terminal to User
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="isFormValid">
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="selectedAccount"
                :items="userAccounts"
                item-text="account_name"
                item-value="account_id"
                label="Select Account"
                prepend-icon="fa-building"
                box
                :rules="[rules.required]"
                @change="loadTerminals"
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-select
                v-model="selectedTerminal"
                :items="availableTerminals"
                item-text="name"
                item-value="id"
                label="Select Terminal"
                prepend-icon="fa-desktop"
                box
                :disabled="!selectedAccount"
                :loading="isLoadingTerminals"
                :rules="[rules.required]"
              >
                <template v-slot:item="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>Code: {{ item.code }} | Type: {{ item.type }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm6>
              <v-checkbox
                v-model="isDefault"
                label="Set as default terminal"
                color="primary"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6>
              <v-checkbox
                v-model="canCharge"
                label="Allow charging on this terminal"
                color="primary"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!isFormValid || isProcessing"
          :loading="isProcessing"
          @click="addTerminal"
        >
          Add Terminal
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'

export default {
  name: 'AddTerminalModal',
  mixins: [ApiMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      required: true
    },
    userAccounts: {
      type: Array,
      default: () => []
    },
    existingTerminalIds: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isFormValid: false,
      isLoadingTerminals: false,
      isProcessing: false,
      selectedAccount: null,
      selectedTerminal: null,
      availableTerminals: [],
      isDefault: true,
      canCharge: true,
      rules: {
        required: value => !!value || 'This field is required'
      }
    }
  },

  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value (val) {
      if (val) {
        this.reset()
      }
    }
  },

  methods: {
    reset () {
      this.selectedAccount = null
      this.selectedTerminal = null
      this.availableTerminals = []
      this.isDefault = true
      this.canCharge = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    async loadTerminals () {
      if (!this.selectedAccount) {
        this.availableTerminals = []
        return
      }

      this.isLoadingTerminals = true
      this.selectedTerminal = null

      try {
        let result = await this.api({
          method: 'get',
          url: '/terminals',
          params: {
            filter: { account_id: this.selectedAccount },
            perPage: '*'
          }
        })

        // Filter out terminals already linked to user
        this.availableTerminals = result.data.rows.filter(
          terminal => !this.existingTerminalIds.includes(terminal.id)
        )
      } catch (error) {
        console.error('Error loading terminals:', error)
        this.availableTerminals = []
      } finally {
        this.isLoadingTerminals = false
      }
    },

    async addTerminal () {
      if (!this.selectedTerminal) {
        return
      }

      this.isProcessing = true
      try {
        await this.api({
          method: 'post',
          url: `/users/${this.userId}/terminals/${this.selectedTerminal}`,
          data: {
            is_default: this.isDefault,
            can_charge: this.canCharge
          }
        })

        Bus.$emit('openModal', {
          status: 'success',
          message: 'Terminal added successfully'
        })

        this.$emit('added')
        this.close()
      } catch (error) {
        Bus.$emit('openModal', {
          status: 'error',
          message: (error.response && error.response.data && error.response.data.error) || 'Error adding terminal'
        })
      } finally {
        this.isProcessing = false
      }
    },

    close () {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/user/AddTerminalModal.vue